const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20villam%20i%C3%A7in%20profesyonel%20temizlik%20teklifi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.';

export default function LuxuryVilla() {
  return (
    <section className="bg-warm-cream py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy leading-tight mb-6">
              BÜYÜK YAŞAM ALANLARI<br />
              <span className="text-gold">PROFESYONEL TEMİZLİK İSTER</span>
            </h2>

            <p className="text-navy/70 text-base md:text-lg leading-relaxed mb-4">
              Villa, residence ve geniş yaşam alanlarında alan büyüdükçe detay, ekip planlaması ve doğru ekipman ihtiyacı da artar.
            </p>

            <p className="text-navy/70 text-base md:text-lg leading-relaxed mb-8">
              VİAYPİİ Temizlik, alanınızı değerlendirerek ihtiyaca uygun profesyonel çalışma planı oluşturur.
            </p>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-base rounded-md transition-colors"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Villam İçin Teklif İstiyorum
            </a>
          </div>

          <div className="order-1 lg:order-2">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/c52848e86401e7fd1e38f0d43c71dd30.png"
              alt="Lüks villa profesyonel temizliği"
              className="w-full h-auto rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}